import React from 'react';
import { Link } from 'react-router-dom';
import './UseCases.css';

const useCases = [
  {
    id: 'ai-receptionist',
    title: 'AI Receptionist',
    icon: 'fas fa-phone-alt',
    description: 'Handle incoming calls, schedule appointments, and provide customer support 24/7.',
    color: '#5a67d8'
  },
  {
    id: '24-7-dispatcher',
    title: '24/7 Dispatcher',
    icon: 'fas fa-truck',
    description: 'Automate dispatch operations, route calls, and manage logistics around the clock.',
    color: '#c44569'
  },
  {
    id: 'ai-callback',
    title: 'AI Callback',
    icon: 'fas fa-phone-volume',
    description: 'Schedule callbacks, manage missed calls, and ensure no customer inquiry goes unanswered.',
    color: '#2c5aa0'
  },
  {
    id: 'ai-chatbot',
    title: 'AI Chatbot',
    icon: 'fas fa-comments',
    description: 'Provide instant text-based support, answer FAQs, and guide customers through your website.',
    color: '#2d8659'
  },
  {
    id: 'customer-support',
    title: 'Customer Support',
    icon: 'fas fa-headset',
    description: 'Handle customer inquiries, troubleshoot issues, and provide technical support instantly.',
    color: '#c7365f'
  },
  {
    id: 'lead-qualification',
    title: 'Lead Qualification',
    icon: 'fas fa-filter',
    description: 'Qualify leads, gather information, and route high-value prospects to your sales team.',
    color: '#d97706'
  },
  {
    id: 'appointment-scheduling',
    title: 'Appointment Scheduling',
    icon: 'fas fa-calendar-check',
    description: 'Automate booking, rescheduling, and cancellation of appointments with calendar integration.',
    color: '#0d9488'
  },
  {
    id: 'order-tracking',
    title: 'Order Tracking',
    icon: 'fas fa-box',
    description: 'Provide real-time order status updates, shipping information, and delivery notifications.',
    color: '#0891b2'
  },
  {
    id: 'technical-support',
    title: 'Technical Support',
    icon: 'fas fa-tools',
    description: 'Troubleshoot technical issues, provide step-by-step guidance, and escalate complex problems.',
    color: '#dc2626'
  }
];

const UseCases = () => {
  return (
    <div className="use-cases-page">
      <div className="use-cases-hero">
        <div className="container">
          <h1>AI Solutions for Every Business Need</h1>
          <p>Explore our use cases and discover how AI can transform your customer service operations</p>
        </div>
      </div>

      <div className="use-cases-content">
        <div className="container">
          <div className="use-cases-grid">
            {useCases.map((useCase) => (
              <Link 
                key={useCase.id} 
                to={`/use-cases/${useCase.id}`}
                className="use-case-card"
                style={{ '--card-color': useCase.color }}
              >
                <div className="use-case-icon" style={{ background: `linear-gradient(135deg, ${useCase.color} 0%, ${useCase.color}dd 100%)` }}>
                  <i className={useCase.icon}></i>
                </div>
                <h3>{useCase.title}</h3>
                <p>{useCase.description}</p>
                <div className="use-case-arrow">
                  <i className="fas fa-arrow-right"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UseCases;

